import Splide from '@splidejs/splide'
import Alpine from 'alpinejs'

export const initQuoteSlider = () => {
    Alpine.data('initQuoteSlider', () => ({
        init() {
            const splide = new Splide(this.$el, {
                type: 'fade',
                arrows: true,
                pagination: false,
            })

            // event on overflowing content to enable / disable interactions
            splide.on('overflow', function (isOverflow) {
                splide.options = {
                    arrows: isOverflow,
                    drag: isOverflow,
                }
            })
            splide.mount()
        },
    }))
}
